/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BranchCreatePage = lazyLoad(
  () => import('./index'),
  module => module.BranchCreatePage
);
